import { render, staticRenderFns } from "./CalendarCom.vue?vue&type=template&id=22270726&scoped=true"
import script from "./CalendarCom.vue?vue&type=script&lang=js"
export * from "./CalendarCom.vue?vue&type=script&lang=js"
import style0 from "./CalendarCom.vue?vue&type=style&index=0&id=22270726&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22270726",
  null
  
)

export default component.exports